import * as navigation from 'Navigation';

export default class ContainerTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'container',
    };
  }
}
